<script>
  import {
    VRadio
  } from 'vuetify/lib'
  export default {
    name: 'wh-radio',
    extends: VRadio
  };
</script>